import $ from 'jquery';
import { breakpoints } from './_site';
import { create as createSlider } from './slider';

export const refresh = () => {
    var $slider = $('.products-slider .slider__cycle');

    if ($slider.length) {
        $slider.each(function() {
            $(this)[0].slick.refresh();
        });
    }
};
export const binds = ($el) => {
    // products
    createSlider($('.products-slider'), {
        fade: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            // {
            //     breakpoint: breakpoints.xl,
            //     settings: {
            //         slidesToShow: 4,
            //         slidesToScroll: 4,
            //     }
            // },
            {
                breakpoint: breakpoints.lg,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                },
            },
            {
                breakpoint: breakpoints.md,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: breakpoints.sm,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: breakpoints.xs,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });
};
